import FormCheckbox from 'controls/checkbox/formCheckbox';
import Close from 'icons/close';
import React from 'react';
import { flushSync } from 'react-dom';
import style from './globalCheck.module.scss';
import cx from 'classnames';

export default function GlobalCheck({
  setGlobalChecked,
  setFakeChecked,
  isAllChecked,
}: {
  setGlobalChecked: (value: React.SetStateAction<boolean>) => void;
  isAllChecked: boolean;
  setIsAllChecked: (value: React.SetStateAction<boolean>) => void;
  setFakeChecked: (value: React.SetStateAction<boolean>) => void;
}) {
  return (
    <div className={style.container}>
      <FormCheckbox
        name="select_all"
        inner_props={{
          form_control_label_props: {
            label: 'Выбрать все',
          },
          checkbox_props: {
            // disabled: true,
            checked: isAllChecked,
            onChange: (e) => {
              // Если событие вызвано взаимодействием пользователя, либо значение true - все чекбоксы выбраны,
              // Исходя из этого можно принудительно выставить глобальное состояние
              if (e.isTrusted) {
                setGlobalChecked(!e.target.checked);
                setTimeout(() => setGlobalChecked(e.target.checked), 0);
              }
            },
          },
        }}
      ></FormCheckbox>
      <div
        className={cx(style.uncheck, 'clickable-text')}
        onClick={() => {
          // Костыль с отключением батчинга
          flushSync(() => {
            setFakeChecked(true);
            setGlobalChecked(true);
          });
          flushSync(() => {
            setFakeChecked(false);
            setGlobalChecked(false);
          });
        }}
      >
        <Close></Close>
        <span>Отменить выбор</span>
      </div>
    </div>
  );
}
